import type { CreatePulsarJob, PulsarBatch, PulsarServer, PulsarServerSummary } from '../types/pulsar';

const BASE = 'https://spy.playcdu.co/api/notes/pulsar';

export class PulsarApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
    this.name = 'PulsarApiError';
  }
}

async function request<T>(path: string, body?: unknown, signal?: AbortSignal): Promise<T> {
  const response = await fetch(`${BASE}${path}`, {
    method: body === undefined ? 'GET' : 'POST',
    cache: 'no-store', credentials: 'include', signal,
    ...(body === undefined ? {} : { headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new PulsarApiError(typeof data?.error === 'string' ? data.error : `CDU Agent could not complete this request (${response.status}).`, response.status);
  return data as T;
}

export const pulsarApi = {
  servers: (signal?: AbortSignal) => request<{ servers: PulsarServerSummary[]; clusters: { id: string | number; server_addresses: string[] }[] }>('/servers', undefined, signal),
  server: (address: string, signal?: AbortSignal) => request<PulsarServer>(`/servers/${encodeURIComponent(address)}`, undefined, signal),
  create: (body: CreatePulsarJob) => request<PulsarBatch>('/jobs', body),
  job: (id: string, signal?: AbortSignal) => request<PulsarBatch>(`/jobs/${encodeURIComponent(id)}`, undefined, signal),
};
